import isSharedFolderSearch from './isSharedFolderSearch';
import { ALL_SUGGESTION_KINDS_LIST, SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST } from '../constants';
import { SearchScenarioId } from 'owa-search-next';
import { SuggestionKind } from 'owa-search-service';

export default function getSupportedSuggestionKinds(scenarioId: SearchScenarioId) {
    if (scenarioId === SearchScenarioId.FilesHub) {
        return SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST;
    } else {
        return isSharedFolderSearch()
            ? getSupportedSharedFolderSuggestions()
            : ALL_SUGGESTION_KINDS_LIST;
    }
}

function getSupportedSharedFolderSuggestions(): SuggestionKind[] {
    // Search in shared folders is only supported for keywords and people.
    return [SuggestionKind.Keywords, SuggestionKind.People];
}
